interface IProps {
  filename: string
}

export const mapAttachments = <T extends IProps>(
  files?: T[] | null
): File[] => {
  if (!files) return []

  return files.map(
    (x: T) =>
      (({
        ...x,
        name: x.filename,
      } as unknown) as File)
  )
}
